import { render } from "./index.vue?vue&type=template&id=18d1339e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BaseFreezeStock/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18d1339e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18d1339e', __exports__)) {
    api.reload('18d1339e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=18d1339e", () => {
    api.rerender('18d1339e', render)
  })

}


export default __exports__